module.exports = __webpack_public_path__ + "static/img/01.3d2bb95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/how_it_works/01.png
// module id = IQ6A
// module chunks = 1